import { Box } from '@material-ui/core';
import {
  Channel,
  ChannelType,
  getMerchantStructureByMerchantId,
  patchChangeDescription,
  patchChangeType,
} from '@nemuru-eng/js-api-client';
import { Dispatch, SetStateAction } from 'react';

import { ConfigurationForm } from '@/components/modules/ChannelDetail/ChannelDetails/components/Configuration/components/ConfigurationForm';
import { ChannelConfigurationFormSchema } from '@/components/modules/ChannelDetail/ChannelDetails/components/Configuration/schemas/ChannelConfigurationFormSchema';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';
import { EditDialogWrapper } from '@/components/shared/components/EditDialogWrapper';
import { useCache } from '@/hooks/requests/useCache';
import { useRequest } from '@/hooks/requests/useRequest';

export const ConfigurationEditWrapper = ({
  merchantId,
  opened,
  setOpened,
  toggleDialog,
  currentChannel,
}: {
  merchantId: string;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
  toggleDialog;
  currentChannel: Channel;
}) => {
  const { request, loading } = useRequest();
  const { revalidate } = useCache(getMerchantStructureByMerchantId, { merchantId });

  const ChannelConfigurationDefaultValues = {
    description: currentChannel.description,
    type: currentChannel.type,
  };

  const onSubmitForm = async (useFormValues: FormValues) => {
    if (useFormValues.description !== currentChannel.description)
      await request(patchChangeDescription, { id: currentChannel.id, description: useFormValues.description });
    if (useFormValues.type !== currentChannel.type)
      await request(patchChangeType, { id: currentChannel.id, type: useFormValues.type });
    toggleDialog();
    revalidate();
  };

  return (
    <EditDialogWrapper
      opened={opened}
      setOpened={setOpened}
      handleClose={toggleDialog}
      DialogProps={{
        maxWidth: 'sm',
        fullWidth: true,
      }}
      title={'CHANNEL_CONFIGURATION'}
      onSubmitForm={onSubmitForm}
      isLoading={loading}
      formSchema={ChannelConfigurationFormSchema}
      defaultValues={ChannelConfigurationDefaultValues}
    >
      <Box pt={2}>
        <ConfigurationForm currentChannel={currentChannel} fieldVariant={FieldVariant.form} fullWidth />
      </Box>
    </EditDialogWrapper>
  );
};

interface FormValues {
  description: string;
  type: ChannelType;
}
